module.exports = __webpack_public_path__ + "img/10.bd42b2df.jpg";